import React from 'react';
import type { SingPitchId } from '../../lib/melody/clingCantaConfig';
import { noteVisual } from '../../lib/melody/clingCantaEngine';
import {
  CLING_PIANO_ROLL_PITCHES,
  MIN_ACTIVE_PITCHES,
  type ClingNoteSelection,
} from '../../lib/melody/clingNoteSelectionConfig';

const LANE_H = 15;
const ROLL_PAD = 4;

interface ClingConfigNoteRollProps {
  selection: ClingNoteSelection;
  onTogglePitch: (pitchId: SingPitchId) => void;
}

export const ClingConfigNoteRoll: React.FC<ClingConfigNoteRollProps> = ({
  selection,
  onTogglePitch,
}) => {
  const lanes = CLING_PIANO_ROLL_PITCHES;
  const contentH = ROLL_PAD * 2 + lanes.length * LANE_H;
  const activeSet = new Set(selection.activePitches);

  return (
    <div className="cling-config-note-roll">
      <p className="cling-config-note-roll-hint">
        Toca las pistas para activarlas. Mínimo {MIN_ACTIVE_PITCHES} notas.
      </p>
      <div className="cling-config-note-roll-scroll">
        <div className="cling-config-note-roll-inner" style={{ height: contentH }}>
          {lanes.map((pitchId) => {
            const active = activeSet.has(pitchId);
            const visual = noteVisual(pitchId);
            const top = ROLL_PAD + lanes.indexOf(pitchId) * LANE_H;
            return (
              <button
                key={pitchId}
                type="button"
                className={`cling-config-note-roll-lane ${active ? 'cling-config-note-roll-lane--active' : ''}`}
                style={{
                  top,
                  height: LANE_H,
                  ['--lane-fill' as string]: visual.fill,
                  ['--lane-color' as string]: visual.color,
                }}
                onClick={() => onTogglePitch(pitchId)}
                aria-pressed={active}
                title={active ? `Quitar ${pitchId}` : `Añadir ${pitchId}`}
              >
                <span className="cling-config-note-roll-lane-label">
                  {pitchId.replace(/(\d)/, ' $1')}
                </span>
                {active && <span className="cling-config-note-roll-lane-dot" aria-hidden />}
              </button>
            );
          })}
        </div>
      </div>
      <p className="cling-config-note-roll-count">
        {selection.activePitches.length} notas activas
      </p>
    </div>
  );
};

export default ClingConfigNoteRoll;
